module.exports = __webpack_public_path__ + "assets/media/m1_1.7da7b5e1.mp4";